import { truncate } from 'lodash';
import Vue from 'vue';

Vue.filter('truncate', function (value: string, length: number = 75) {
  return truncate(value, { length });
});
